import { AgGridReactProps } from 'ag-grid-react';
import styled, { css } from 'styled-components';
import { Grid as GridAtom } from 'components/atoms/grid';
import { Text03 } from 'components/styles';
// eslint-disable-next-line import/no-internal-modules
import { MoreActions } from '../status-name-cell/styles';

const GroupEditingContainer = css`
  [col-id='ag-Grid-AutoColumn'].ag-cell-inline-editing {
    > div {
      padding-left: var(--group-cell-padding-left);
    }
  }
`;

export const StyledGrid = styled(GridAtom)<AgGridReactProps>`
  .ag-row {
    border-color: var(--table-border-color);
  }
  .ag-root-wrapper {
    border: none;
  }

  ${MoreActions} {
    top: 4px;
    padding: 0;
    button {
      width: var(--input-size-sm);
      height: var(--input-size-sm);
    }
  }

  .ag-body-horizontal-scroll-container,
  .ag-body-horizontal-scroll,
  .ag-body-horizontal-scroll > * {
    /* added here so that we dont get horizontal scroll container for project templates list */
    height: 0px !important;
    min-height: 0px !important;
    max-height: 0px !important;
  }

  .ag-row.is-private {
    background-color: var(--private-01);
  }

  .ag-row.is-private.ag-row-hover {
    background-color: var(--private-02);
  }

  .ag-row-hover {
    ${MoreActions} {
      opacity: 1;
    }
  }

  .ag-cell {
    border: 2px solid transparent;
  }

  .ag-cell-focus {
    border: 2px solid var(--primary-color) !important;
  }

  [col-id='duration'],
  [col-id='startDay'] {
    &.ag-cell.ag-cell-inline-editing {
      padding-left: 0;
      padding-right: 0;
    }
    &.ag-cell.not-editable {
      ${Text03};
    }
  }

  .ag-row-group-indent-0 {
    .ag-group-value {
      width: 308px;
      font-weight: var(--font-weight-bold);
    }
  }

  .ag-row-group-indent-1 {
    .ag-group-value {
      width: 280px;
    }
  }
  .ag-row-group-indent-2 {
    .ag-group-value {
      width: 250px;
    }
  }
  .ag-row-group-indent-3 {
    .ag-group-value {
      width: 220px;
    }
  }

  .ag-row-level-0 {
    --group-cell-padding-left: 32px;
  }
  .ag-row-level-1 {
    --group-cell-padding-left: 60px;
  }
  .ag-row-level-2 {
    --group-cell-padding-left: 88px;
  }
  .ag-row-level-3 {
    --group-cell-padding-left: 116px;
  }
  .ag-center-cols-viewport {
    overflow: hidden;
  }
  ${GroupEditingContainer};
`;

export const GridContainer = styled.div`
  height: calc(100% - 46px);
  width: 100%;
`;
